<template>
    <div
        class="aup-shadowcard"
        :class="{ 'aup-shadowcard--with-footer': hasFooter }" >
        <slot/>
    </div>
</template>
<script>
	export default {
        name: "BaseShadowCard",
        props: {
            hasFooter: {
                type: Boolean,
                default: false,
            }
        }
    };
</script>

<style lang="scss">
    @import "../../assets/scss/all";
    .aup-shadowcard {
        background-color: $sony-white;
        box-shadow: 6px 6px 10px 4px rgba(19, 19, 19, 0.096);
        padding: 2rem;

        @media (max-width: 762px) {
            padding: 1.5rem;
        }

        &--with-footer {
            padding-bottom: 0;
        }
    }
</style>
